import { useMutation, useQueryClient } from "react-query";
import { post } from "../../../../http";
import { IBulkSavedExportSettingsMutationPayload } from "./saveBulkExportState.types";
import { savedExortSettings } from "../../bulkBaseUrl";
import { savedExportSettingsKey } from "../../queries/savedExportSettings/savedExportSettings.constants";
import { favouriteItemsKey } from "../../../../favourites/api";

export function useSaveBulkExportStateMutation() {
  const queryClient = useQueryClient();
  const { isLoading, isError, isSuccess, mutate } = useMutation(
    (payload: IBulkSavedExportSettingsMutationPayload) => saveExportSettings(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(savedExportSettingsKey);
        queryClient.invalidateQueries(favouriteItemsKey);
      },
    }
  );
  return { isBulkExportLoading: isLoading, isBulkExportError: isError, isBulkExportSuccess: isSuccess, saveBulkExportSettings: mutate };
}

async function saveExportSettings(payload: IBulkSavedExportSettingsMutationPayload) {
  try {
    const { ...data } = payload;
    const url = savedExortSettings;
    await post(url, data, {
      headers: {
        Accept: "*/*",
      },
    });
  } catch (err) {
    console.error(err);
  }
}
